/**
 * Generates a random number (integer or floating-point) within the specified range (inclusive).
 *
 * @param min - The minimum value (inclusive).
 * @param max - The maximum value (inclusive).
 * @returns A random number between min and max.
 * @throws An error if min is greater than max.
 */
export const getRandomNumberInclusive = <T extends number>(
  min: T,
  max: T,
): T => {
  if (min > max) {
    throw new Error(
      'Minimum value must be less than or equal to the maximum value.',
    );
  }
  // Type assertion is needed because Math.random() * (max - min + 1) could be a float
  return (Math.floor(Math.random() * (max - min + 1)) + min) as T;
};
